// extracted by mini-css-extract-plugin
module.exports = {"bottom":"index-module_bottom_2r4Bz","btn":"index-module_btn_1R6y-","disabled":"index-module_disabled_2GFsi"};